import { Spinner } from "@climatepartner/components/Spinner";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { CCFRoutes } from "../../modules/ccf/routes";
import { CustomerDashboardPage } from "../../modules/customer-dashboard/lazy-pages";
import { CustomerEmissionFactorsRoutes } from "../../modules/customer-emission-factors/routes";
import { PCFRoutes } from "../../modules/pcf/routes";
import { OrganisationAccessGuard } from "../../shared/auth/guards/organisation-access.guard";
import { CUSTOMER_ROUTE_SEGMENTS } from "../../shared/routing/paths/customer";
import { commonLabels } from "../../shared/ui/labels/common-labels";

/**
 * `/customer/:customerId` — not a module of its own, but the URL prefix four modules share:
 *
 *   customer-dashboard        index
 *   customer-emission-factors /emission-factors-library
 *   pcf                       /pcf/**    (module table: `modules/pcf/routes.tsx`)
 *   ccf                       /ccf/**    (module table: `modules/ccf/routes.tsx`)
 *
 * It exists so the organisation-access check is stated once, at the level that owns the
 * `:customerId` param, rather than repeated in each of the four.
 */
export const CustomerAreaRoutes = {
  element: (
    <OrganisationAccessGuard>
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
    </OrganisationAccessGuard>
  ),
  path: `${CUSTOMER_ROUTE_SEGMENTS.root}/${CUSTOMER_ROUTE_SEGMENTS.customerId}`,
  handle: { crumb: commonLabels.navigation.calculate },
  children: [{ index: true, element: <CustomerDashboardPage /> }, CustomerEmissionFactorsRoutes, PCFRoutes, CCFRoutes],
};
